import { TargetingQuotaApiModel } from '../../../api/targeting/model/targeting-quota-api.model';

export class TargetingQuotaInfo {
    nextResetDate: Date;
    periodStartDate: Date;
    customResetDate: Date;

    constructor(apiModel?: TargetingQuotaApiModel) {
        if (apiModel) {
            this.nextResetDate = this.setDateFromApiModel(apiModel.nextResetDate);
            this.periodStartDate = this.setDateFromApiModel(apiModel.previousResetDate);
            this.customResetDate = this.setDateFromApiModel(apiModel.customResetDate);
        }
    }

    private setDateFromApiModel(date: Date): Date {
        if (date) {
            return new Date(date);
        }
        return null;
    }
}
